// 获取用户基本信息
export const GET_TASK_START = "GET_TASK_START";
export const GET_TASK_REPORT = "GET_TASK_REPORT";
export const GET_TASK_DONE = "GET_TASK_DONE";

// 下载任务报表
// export const DOWNLOAD_TASK_START = "DOWNLOAD_TASK_START";
// export const DOWNLOAD_TASK_DONE = "DOWNLOAD_TASK_DONE"; 


// WEBPACK FOOTER //
// ./src/constants/task.js